import React,{useState} from 'react'
import boltico from '../images/thordetails/bolt_icon.svg';
import EarthingelectrodeSubMenu from './EarthingelectrodeSubMenu';

import zinc from '../images/earthing/zinc_z/zinc_big.png';
import zinc2x from '../images/earthing/zinc_z/zinc_big@2x.png';
import Image from 'next/image';
    const Aseel_z_earthing = () => {
        const [selectedSubmenu, setSelectedSubmenu] = useState('');

        const handleImageClick = (system) => {
            setSelectedSubmenu(system);
            //console.log("selcet system is"+system);
        };

        return (
            <>
            <EarthingelectrodeSubMenu onImageClick={handleImageClick}/>
            <div className='w-full flex justify-center items-center my-3 px-2 lg:px-0'>
                <div className=' container mx-auto max-w-screen-xl flex flex-col justify-center  px-2 lg:px-0'>
                    <div className='flex justify-center'>
                        
                        <div className='flex justify-center items-center'>
                        <Image src={zinc}  
                                                srcSet={`${zinc} 1x,${zinc2x} 2x`} alt="Zinc Coated Earthing Electrode by Ashlok Safe Earthing Electrode Limited for Efficient Earthing Systems"
                                                /> 
                        </div>
                       
                    </div>
                    <div className='flex flex-col items-start'>
                        <h1 className=' text-xl lg:text-2xl text-ashred tracking-wider font-semibold' ><span className='vollkorn-sc-semibold'>ASEEL Z <span className=' text-4xl px-1'>|</span> Zinc Coated Electrode(<span style={{fontSize:'80%'}}>s</span>) </span></h1>
                        <p className=' text-base text-justify p-common'>With curated <span className='vollkorn-sc-semibold'>Ashlok’s</span> Design Process and the solitary compound formula developed by <span className='vollkorn-sc-semibold'>Ashlok</span>, the zinc coated electrodes are designed by pipe-in-pipe technology filled with Crystalline Conductive Compound(CCC) CompactFill for current dissipation and anti corrosive properties.</p>
                       
                    </div>
                    
                    
                </div>
            </div>
            <div className='w-full flex justify-center items-center bg-ashgray1 px-2 lg:px-0'>
                <div className=' container mx-auto max-w-screen-xl flex flex-col justify-center  px-2 lg:px-0 lg:my-3'>
                
                    <div className='flex  flex-col lg:flex-row lg:space-x-10'>
                    

                        <div className='w-full lg:w-1/2'>
                        <p className=' text-1xl font-extrabold text-ashred '>Features & Benefits</p>
                            <ul className="list-none">
                            <li className="flex items-start p-common "><Image alt="" src={boltico} className="mr-2 my-1.5"/>Zinc coated earthing electrode</li>
                            <li className="flex items-start p-common "><Image alt="" src={boltico} className="mr-2  my-1.5"/>Coating thickness exceeding 100 microns </li>
                            <li className="flex items-start p-common "><Image alt="" src={boltico} className="mr-2  my-1.5 "/>Controlled coating quality</li>
                            <li className="flex items-start p-common "><Image alt="" src={boltico} className="mr-2  my-1.5"/>Customisation is available as per customers requirement</li>
                                             </ul>
                        </div>
                       
                        <div className='w-full lg:w-1/2'>
                            <ul className="list-none lg:ml-2">
                            <li className="items-start p-common text-ashgray1 text-sm hidden lg:block">Improved resistance against corrosion</li>
                            <li className="flex items-start p-common py-1"><Image alt="" src={boltico} className="mr-2  my-1.5 "/>Improved resistance against corrosion</li>
                            <li className="flex items-start p-common"><Image alt="" src={boltico} className="mr-2 my-1.5"/>Granular surface texture for comprehensive BFC distribution and enhanced current dispersion</li>
                            <li className="flex items-start p-common"><Image alt="" src={boltico} className="mr-2 my-1.5 "/>Cathodic corrosion protection</li>
                                 </ul>
                        </div>
                        <div className='w-1/4'></div>
                    </div>
                </div>
            </div>
            <div className='w-full flex justify-center items-center px-2 lg:px-0'>
             
                <div className=' container mx-auto max-w-screen-xl flex flex-col justify-center px-2 lg:px-0 my-2 lg:my-3'>
                <p className='text-lg lg:text-xl'>Zinc Coated Earthing Electrode Variant</p>
                    <div className='flex'>
                        <div className='container w-full '>
                                    <table className=" w-full divide-y divide-gray-200 p-common text-sm lg:text-lg">
                                        <thead className='w-full mb-2'>
                                            
                                            <tr className="bg-ashred">

                                            <th className=" px-4 py-2 text-white">Model</th>
                                            <th className="  px-4 py-2 text-white">Length (Mtr)</th>
                                            <th className="  px-4 py-2 text-white">Inner Pipe Dia  (mm)</th>
                                            <th className="  px-4 py-2 text-white">Outer Pipe Dia  (mm)</th>
                                           
                                            </tr>
                                        </thead>
                                        <tbody className="">
                                            <tr className="bg-gray-200">
                                            <td className=" px-4 py-2 text-center">ASEEL 192 Z</td>
                                            <td className=" px-4 py-2 text-center">2</td>
                                            <td className=" px-4 py-2 text-center">26</td>
                                            <td className=" px-4 py-2 text-center">48 </td>
                                            </tr>
                                            <tr className="bg-white">
                                            <td className=" px-4 py-2 text-center">ASEEL 193 Z</td>
                                            <td className=" px-4 py-2 text-center">3</td>
                                            <td className=" px-4 py-2 text-center">26</td>
                                            <td className=" px-4 py-2 text-center">48 </td>
                                            </tr>
                                            <tr className="bg-gray-200">
                                            <td className=" px-4 py-2 text-center">ASEEL 392 Z</td>
                                            <td className=" px-4 py-2 text-center">2</td>
                                            <td className=" px-4 py-2 text-center">42</td>
                                            <td className=" px-4 py-2 text-center">76</td>
                                            </tr>
                                            <tr className="bg-white">
                                            <td className=" px-4 py-2 text-center">ASEEL 393 Z</td>
                                            <td className=" px-4 py-2 text-center">3</td>
                                            <td className=" px-4 py-2 text-center">42</td>
                                            <td className=" px-4 py-2 text-center">76</td>
                                            </tr>
    
                                           
                                        
                                        </tbody>
                                    </table>
                        </div>
                        
                    </div>
                
                
                       
                       
                    
                </div>
                
            </div>
            <div className='w-full flex justify-center items-center mt-3 px-2 lg:px-0 bg-ashgray1'>
                <div className=' container mx-auto max-w-screen-xl flex flex-col justify-center  px-2 lg:px-0 my-3'>
                    <div className='flex flex-col justify-center'>
                        <h2 className=' text-2xl'><span className="vollkorn-sc-semibold">Ashlok</span> Zinc Coated Electrodes – Reliable Galvanised Electrodes for Enhanced Earth Rod Protection</h2>
                        <p className=' text-base text-justify'>The <span className="vollkorn-sc-semibold">Ashlok</span> Zinc Coated Electrode is a durable galvanised electrode designed to
protect against galvanic corrosion and ensure long-lasting performance in
grounding systems. Ideal for use as an earth rod, it offers excellent conductivity
and corrosion resistance for industrial, commercial, and residential applications.
Choose <span className="vollkorn-sc-semibold">Ashlok</span> for effective and reliable earthing solutions that enhance safety and
durability.</p>
                    </div>
                </div>
            </div>
            </>
          )
    }
    
    export default Aseel_z_earthing
    